module.exports = __webpack_public_path__ + "img/lithuania.b46e2861.svg";